import axios from 'axios';
import APIS from '../../apis/houseTreePeople';
import qs from 'qs';
import {
  callbackHandler,
} from '../callbackHandler';

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    getHtpViewReport(context, params) {
      return axios.get(APIS.htpViewReport, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.htpViewReport, res);
        return res.data;
      })
    },
    htpUploadImage(context, { env, params, callback } = {}) {
      return axios.post(APIS.htpUploadImage, params)
        .then(function (res) {
        callbackHandler(APIS.htpUploadImage, res);
        return res.data;
      })
    },
    getHtpPoster(context, params) {
      return axios.get(APIS.fetchPoster, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.fetchPoster, res);
        return res.data;
      })
    },
    getHtpTeacher(context, params) {
      return axios.get(APIS.fetchTeacher, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.fetchTeacher, res);
        return res.data;
      })
    },
    getScaleModulesMsg(context, {env, params}={}){
      const api = APIS.scaleModulesMsg;
      return axios.get(api, {params}).then((res)=>{
        callbackHandler(api, res);
        return res.data
      })
    },
    fetchAuthHouseTreeHuman(context, params){
      return axios.get(APIS.authHouseTreeHuman, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.authHouseTreeHuman, res);
        return res.data;
      })
    },
    generalUploadImage(context, { env, params, callback } = {}) {
      return axios.post(APIS.generalUploadImage, params)
        .then(function (res) {
          callbackHandler(APIS.generalUploadImage, res);
          return res.data;
        })
    },
    getYzrViewReport(context, params) {
      return axios.get(APIS.yzrViewReport, {
          params: params.params
      }).then(function (res) {
          callbackHandler(APIS.yzrViewReport, res);
          return res.data;
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/houseTreePeople.js